import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { IMAGES } from '../mock';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';

const BLOCK_META = [
  { bg: 'bg-pastel-lav', image: IMAGES.serviceTable, href: '#solutions' },
  { bg: 'bg-pastel-peach', image: IMAGES.solutionHotel, href: '#solutions' },
];

export default function ProblemSolution() {
  const { t } = useI18n();
  const { problemBlocks } = useBookersContent();
  const blocks = problemBlocks.map((b, i) => ({ ...b, ...BLOCK_META[i] }));

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
        <h2 className="font-display text-4xl md:text-5xl text-center max-w-3xl mx-auto reveal text-[#0b0b0f]">
          {t('problemSolution.title')}
        </h2>

        <div className="mt-14 space-y-6">
          {blocks.map((b, i) => (
            <div key={b.label} className={`reveal ${b.bg} rounded-[2rem] overflow-hidden border border-black/5`}>
              <div className="grid lg:grid-cols-2 items-stretch">
                <div className={`p-8 md:p-12 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <h3 className="font-display text-2xl md:text-3xl text-[#0b0b0f]">{b.label}</h3>
                  <div className="mt-7 grid sm:grid-cols-2 gap-7">
                    <div>
                      <p className="text-sm font-semibold text-[#0b0b0f]">{t('problemSolution.problemLabel')}</p>
                      <p className="text-[#5a5a63] mt-2 text-[15px] leading-relaxed">{b.problem}</p>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#76B828]">{t('problemSolution.solutionLabel')}</p>
                      <p className="text-[#5a5a63] mt-2 text-[15px] leading-relaxed">{b.solution}</p>
                    </div>
                  </div>
                  <a href={b.href} className="mt-8 inline-flex items-center gap-1.5 btn-pill btn-dark px-6 py-3 text-sm">
                    {t('problemSolution.learnMore')} <ArrowUpRight size={16} />
                  </a>
                </div>
                <div className={`min-h-[260px] ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <img src={b.image} alt={b.label} className="w-full h-full object-cover" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
